export default __webpack_public_path__ + "assets/icons/close-fat.9f093710.svg";